import { render, staticRenderFns } from "./LogisticsSection.vue?vue&type=template&id=3765de59&scoped=true&"
import script from "./LogisticsSection.vue?vue&type=script&lang=js&"
export * from "./LogisticsSection.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsSection.vue?vue&type=style&index=0&id=3765de59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3765de59",
  null
  
)

export default component.exports